import { SoDataTableHeader } from "@/types/components/SoDataTable"
import { SoExportCsvButtonData } from "@/components/dataTable/SoExportCsvButton.vue"
import { SmartMeterEligibleForExchangeRowError } from "@/api/backofficeRest/generated/model"
import { formatDateDashed } from "@/helpers/dateHelper"
import dayjs from "dayjs"

export const smartMeterEligibleForExchangeErrorHeaders: SoDataTableHeader[] = [
  { title: "row_number", key: "rowNumber" },
  { title: "mpxn", key: "mpxn" },
  { title: "meter_serial_number", key: "meterSerialNumber" },
  { title: "fuel", key: "fuel" },
  { title: "meter_type", key: "meterType" },
  { title: "exchange_eligibility_reason", key: "exchangeEligibilityReason" },
  { title: "confirmed_etc_waived", key: "confirmedEtcWaived" },
  { title: "error_reason", key: "errorReason" },
]

interface ISmartMeterEligibleForExchangeErrorExporter {
  getConfig: () => {
    data: SoExportCsvButtonData
    headers: SoDataTableHeader[]
    fileName: string
  }
}

export class SmartMeterEligibleForExchangeErrorExporter implements ISmartMeterEligibleForExchangeErrorExporter {
  private readonly exportData: SmartMeterEligibleForExchangeRowError[] | null
  private readonly originalFileName: string

  constructor(
    exportData: SmartMeterEligibleForExchangeRowError[] | null,
    originalFileName = "",
  ) {
    this.exportData = exportData
    this.originalFileName = originalFileName
  }

  public getConfig() {
    return {
      data: this.parseDataForCsv(),
      headers: smartMeterEligibleForExchangeErrorHeaders,
      fileName: this.getFileName(),
    }
  }

  public parseDataForCsv(): SoExportCsvButtonData {
    if (!this.exportData?.length) {
      return { isLoading: false, items: [] }
    }

    const items = this.exportData.map((row) => {
      const item: Record<string, string | number> = {}
      smartMeterEligibleForExchangeErrorHeaders.forEach((header) => {
        const key = header.key as keyof SmartMeterEligibleForExchangeRowError
        item[key] = row[key] ?? ""
      })
      return item
    })

    return { isLoading: false, items }
  }

  private getFileName(): string {
    const date = formatDateDashed(dayjs())
    if (this.originalFileName) {
      return `smart-meters-eligible-for-exchange-errors-${date} - ${this.originalFileName}`
    }
    return `smart-meters-eligible-for-exchange-errors-${date}.csv`
  }
}
